export default __webpack_public_path__ + "static/media/G0780.34I-36923_-21732_0.1654023360000.9ca5dbc4.jpg";